import { Info } from 'lucide-react'
import { cn } from '@/lib/utils'

/**
 * The SOFT counterpart of `FeatureGated`.
 *
 * `FeatureGated` blocks a whole route when its primary module is off.
 * This renders in place of a single widget when a module the screen merely
 * *uses* is off — an equipment picker inside a form, the MR demographic fields,
 * the material list on a procedure step.
 *
 * It exists because the failure it replaces is indistinguishable from real data:
 * every one of those hooks swallows the backend's 403 into `data ?? []`, so the
 * user saw an empty dropdown and no reason for it. An empty picker reads as
 * "there is no equipment configured"; this reads as "your admin turned this
 * off", which is the difference between a support ticket and a shrug.
 */
export function FeatureDisabledNote({
  label,
  className,
}: {
  /** The module's product name, e.g. "Equipment" — matches the catalog label. */
  label: string
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-md border border-dashed border-border bg-muted/40 px-3 py-2 text-xs text-muted-foreground',
        className,
      )}
    >
      <Info className='h-3.5 w-3.5 shrink-0' />
      <span>{label} is disabled for this tenant.</span>
    </div>
  )
}
